import { useFeatureFlags } from '@contexts/featureFlags'
import { contactSupport } from '@helpers/support'
import { useCopyToClipboard } from '@hooks/useCopyToClipboard'
import PradawnyPatrycy from '@images/checkout/support.png'
import { Button, CustomLink, Heading, Icon, Image, Spreader } from '@ui-kit'
import { Trans, useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

export const HelpSection = () => {
  const { t } = useTranslation()

  const [handleCopy] = useCopyToClipboard(t('support.email'))

  const hasAccessToFreePlanRestriction = useFeatureFlags(
    'FREE_PLAN_RESTRICTIONS'
  )

  const handleContactSupport = () => contactSupport()

  return (
    <Row vertical='center'>
      <Image src={PradawnyPatrycy} width={`${32}px`} />

      <Spreader spread={15} />

      <Column>
        <Heading level={5}>
          <Trans i18nKey='checkout.plans.header.help.section' />
        </Heading>

        {hasAccessToFreePlanRestriction ? (
          <Row vertical='center'>
            <Button
              size={12}
              variant='text-neutral'
              onClick={handleCopy}
              isSquare
            >
              <Icon icon='icon-file-copy' />
            </Button>

            <Spreader spread={5} />

            <CustomLink href={t('word.create-support-ticket.url')}>
              {t('support.email')}
            </CustomLink>
          </Row>
        ) : (
          <CustomLink onClick={handleContactSupport}>
            {t('checkout.plans.header.help.section.link')}
          </CustomLink>
        )}
      </Column>
    </Row>
  )
}

HelpSection.displayName = 'CheckoutPlansHeaderHelpSection'
